import { autoinject } from "aurelia-framework";
import { I18N } from "aurelia-i18n";

@autoinject
export class DegreeFormatValueConverter {

	constructor(private i18n: I18N) { }
	toView(value: number) {

		if (value === null || value === undefined || isNaN(value)) {
			return this.i18n.tr("offline");
		}
		if (isNaN(value)) {
			return null;
		}
		return `${value}°`;
	}
}